import "./TwoColumnLayout.scss";

export default function TwoColumnLayout(props) {
  return (
    <div className="two-column-layout">
      <div className="row box-shadow">
        <div className={props.imgStyle}>
          <img className="contacts-image" src={props.imgSrc}></img>
        </div>
        <div className={props.style}>{props.body}</div>
      </div>
    </div>
  );
}
